import { ConnectResult, createPromiseClient } from '@/connect';
import {
  CompanyService,
  ListCompanyDetailsResponse,
} from '@/connect/gen/modules/apiengine/services/companies/companies_pb';

export * from '@/connect/gen/modules/apiengine/services/agreements/agreements_pb';

export const companiesService = new (class {
  public readonly promiseClient = createPromiseClient(CompanyService);

  public async queryCompanies(): Promise<ConnectResult<ListCompanyDetailsResponse>> {
    const result = await this.promiseClient.listCompanyDetails({});
    return result as ConnectResult<ListCompanyDetailsResponse>;
  }
})();
